<template>
  <section id="dudas">
    <div class="cta-container">
      <div class="cta-content">
        <h2 class="mb-3">¿Listo para impulsar tu proyecto?</h2>
        <p>Hablemos sobre cómo podemos ayudarte a alcanzar tus objetivos digitales.</p>
        <div class="contact-methods">
          <a target="_blank" href="https://wa.me/541123965757" class="wa-button">
            <i class='bx bxl-whatsapp'></i>
            <span>+54 11 2396-5757</span>
          </a>
        </div>
      </div>
      <div class="cta-visual">
        <div class="pulse-ring"></div>
        <img src="/images/whatsapp.png" alt="Icono de Whatsapp" class="wa-icon">
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
#dudas {
  width: 100%;
  padding: 6rem 2rem;
  background: var(--bg-color);
  display: flex;
  justify-content: center;
}

.cta-container {
  max-width: 1000px;
  width: 100%;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  border-radius: 30px;
  padding: 4rem 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 20px 40px var(--primary-glow);
  position: relative;
  overflow: hidden;
  color: white;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z' fill='rgba(255,255,255,0.05)' fill-rule='evenodd'/%3E%3C/svg%3E");
    pointer-events: none;
  }
}

.cta-content {
  max-width: 500px;
  z-index: 1;

  h2 {
    font-size: 3rem;
    color: white;
    line-height: 1.1;
  }

  p {
    font-size: 1.1rem;
    opacity: 0.9;
    margin-bottom: 2rem !important;
  }
}

.wa-button {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  background: white;
  color: var(--primary) !important;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: none;
  transition: all var(--duration);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);

  i {
    font-size: 1.5rem;
    color: #25D366;
  }

  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 15px 30px rgba(0,0,0,0.15);
  }
}

.cta-visual {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.wa-icon {
  width: 140px;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 20px 30px rgba(0,0,0,0.2));
  animation: float-small 4s ease-in-out infinite;
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 50%;
  opacity: 0.1;
  animation: pulse 3s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes float-small {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes pulse {
  0% { transform: scale(0.8); opacity: 0.2; }
  100% { transform: scale(1.5); opacity: 0; }
}

@media screen and (max-width: 900px) {
  .cta-container {
    flex-direction: column;
    text-align: center;
    padding: 3rem 2rem;
    gap: 3rem;
  }
  .cta-content h2 { font-size: 2.5rem; }
}
</style>
<script setup lang="ts">
</script>